var service = {};

if (window.location.href.indexOf('localhost') > -1) {
    service.API_URL = 'https://sc-api.pibncb.com/api/v1';
} else {
    service.API_URL = 'https://sc-api.pibncb.com/api/v1';
}

export default service;
